import { render, staticRenderFns } from "./DoctorsRegisterContent.vue?vue&type=template&id=53510fe2&scoped=true&"
import script from "./DoctorsRegisterContent.vue?vue&type=script&lang=ts&setup=true&"
export * from "./DoctorsRegisterContent.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./DoctorsRegisterContent.vue?vue&type=style&index=0&id=53510fe2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53510fe2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53510fe2')) {
      api.createRecord('53510fe2', component.options)
    } else {
      api.reload('53510fe2', component.options)
    }
    module.hot.accept("./DoctorsRegisterContent.vue?vue&type=template&id=53510fe2&scoped=true&", function () {
      api.rerender('53510fe2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/profile/doctors/register/index/DoctorsRegisterContent/DoctorsRegisterContent.vue"
export default component.exports